const editGroup = (state, action) => {
  switch (action.status) {
    case 'success':
    case 'error':
      return {
        ...state,
        editGroupDialogOpenFor: null,
      };
    default:
      return state;
  }
};

export default editGroup;
